import React, { useContext, useState, useEffect, useRef } from 'react';
import { VERSION, VERSIONMIN } from './api/Globals';
import { helpAuth } from './helpers/helpAuth';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { SplitButton } from 'primereact/splitbutton';
import AuthContext from './context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { LABELTEXT } from './api/Globals';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { helpHttp } from './helpers/helpHttp';
import { BASE_API } from './api/Globals';
import { Toast } from 'primereact/toast';
import { storage } from './helpers/storage';


export const AppTopbar = (props) => {

    const { name, nameTipoUsuario, tienda, nameCiclo, refreshName, handleCloseSesion, handleCiclo } = useContext(AuthContext);
    const [auth, setAuth] = useState(false);
    const [file, setFile] = useState(null)
    const [dialogConfirmar, setDialogConfirmar] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);

    const [cicloescolar, setCicloescolar] = useState(false);
    const [cicloescolar2, setCicloescolar2] = useState(false);
    const [perfil, setPerfil] = useState(null);
    const [getCiclos, setGetCiclos] = useState([]);
    const [ciclo, setCiclo] = useState(null);
    const [seetoast, setSeetoast] = useState(true);
    const [banderaCiclo, setBanderaCiclo] = useState(false);
    const [disableGuardar, setDisableGuardar] = useState(true);
    const cicloSel = storage.get('ciclo')
    const navigate = useNavigate();
    const toast = useRef(null);
    const isPerfil = storage.get('perfilid')
    const token = storage.get('token');

    let indice = name !== null && name.indexOf(" ")
    let userName = name !== null && name //name.substring(0, indice)
    let tiendaName = tienda !== null && tienda

    const [selectedCiclo, setSelectedCiclo] = useState(null);
    const ciclos = [
        { descripcion: '2022-2023', idCicloEscolar: '1' },
        { descripcion: '2023-2024', idCicloEscolar: '2' },
        { descripcion: '2024-2025', idCicloEscolar: '3' },
    ];

    const [videotutorial, setVideotutorial] = useState(false);
    const [videoUrl, setVideoUrl] = useState("");

    useEffect(() => {
        async function abrirUrl() {
            if (token !== null && cicloSel === null) {
                const yaVioVideo = storage.get("videoTutorialVisto");
                if (!yaVioVideo) {
                    const url = await getLinkVideotutorialUltimo();

                    if ([16].includes(isPerfil) && url.length > 0) {
                        setVideoUrl(url);
                        setVideotutorial(true);
                    } else {
                        setCicloescolar2(true)
                    }
                }
            }
        }

        abrirUrl();
    }, [token])

    // useEffect(() => {
    //     getLinkVideotutorialUltimo();
    // }, []);

    useEffect(() => {
        let a = helpAuth();
        setAuth(a.auth);
        setPerfil(a.perfil);
        refreshName();
    }, [helpAuth, handleCloseSesion]);

    useEffect(() => {
        if (cicloescolar === true || cicloescolar2 === true) {
            setDisableGuardar(true)
            helpHttp().post(`${BASE_API}Usuarios/SpdRptCicloEscolar`, {
                body: {
                    TipoPerfil: perfil
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                const cicloRes = (cicloSel !== null && res.ITEMS.find(x => x.IdCicloEscolar === cicloSel.IdCicloEscolar) !== undefined) ? res.ITEMS.find(x => x.IdCicloEscolar === cicloSel.IdCicloEscolar) : res.ITEMS[0];
                setGetCiclos(res.ITEMS)
                setCiclo(cicloRes.IdCicloEscolar);
                setDisableGuardar(false);

            })
        }
    }, [cicloescolar, cicloescolar2])


    const dialogFuncMap = {
        cicloescolar: setCicloescolar,
        cicloescolar2: setCicloescolar2,
        videotutorial: setVideotutorial,
        dialogConfirmar: setDialogConfirmar
    };
    const onHide = (name) => {
        dialogFuncMap[`${name}`](false);
    };

    const AbrirCiclo = async (contenido) => {
        await setCicloescolar(true);
    }

    const AbriConfirmacion = async (contenido) => {
        // await setDialogConfirmar(true);
        setBanderaCiclo(true)
        console.log(ciclo)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: ('Se ha actualizado al ciclo escolar ' + (selectedCiclo !== null ? selectedCiclo.Descripcion : getCiclos.length > 0 && getCiclos.find(x => x.IdCicloEscolar === ciclo).Descripcion)), life: 5000 });
        setTimeout(() => {
            window.location.reload();
            setBanderaCiclo(false);
        }, 1800);
    }

    const seleccionarCiclo = (value) => {
        setConfirmLoading(true);
        setCiclo(value)
        setSelectedCiclo(getCiclos.find(x => x.IdCicloEscolar === value))
        setConfirmLoading(false);

    }

    // setTimeout(()=>{
    //     setSeetoast(!seetoast);
    // }, 5000)


    const showtoast = (cicloescolar) => {
    }


    const handleAvatar = () => {
        const toolbarItems = [
            {
                label: 'Sede: ' + tiendaName
            },
            {
                label: 'Tipo usuario: ' + nameTipoUsuario
            },
            {
                label: 'Entorno: ' + process.env.REACT_APP_ENTORNO
            },
            {
                label: 'Cambiar ciclo escolar' /* + nameCiclo*/,
                icon: 'pi pi-sync',
                command: e => {
                    AbrirCiclo()
                }
            },
            {
                label: 'Cerrar sesión',
                icon: 'pi pi-sign-out',
                command: e => {
                    handleCloseSesion();
                    navigate('/login')
                }
            }
        ];



        const toolbarRightTemplate = <SplitButton label={userName + " " + nameCiclo} icon="pi pi-user" model={toolbarItems} menuStyle={{ width: '12rem' }}></SplitButton>;

        return (
            <>
                {auth && toolbarRightTemplate}
            </>
        );
    }

    const getLinkVideotutorialUltimo = async () => {
        return await helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                sp: "SpdObtenerDatos",
                parametros: []
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res?.SUCCESS) {

                let url = res?.ITEMS?.[0]?.LinkVideoTutorial || "";
                let videoId = null;

                //preparando url
                if (!/^https?:\/\//i.test(url)) {
                    url = "https://www." + url
                }

                //validando url
                if (url.includes("youtube.com/watch")) {
                    videoId = new URL(url).searchParams.get("v");
                } else if (url.includes("youtu.be/")) {
                    videoId = url.split("youtu.be/")[1].split("?")[0];
                }else if (url.includes("youtube.com/shorts/")) {
                    videoId = url.split("youtube.com/shorts/")[1].split("?")[0];
                }

                if (videoId) {
                    return `https://www.youtube.com/embed/${videoId}`;
                }

                return url;
            }
        })
    }


    return (
        <>
            <Toast ref={toast} position='top-right' />
            <div className="layout-topbar">
                <div className="layout-topbar-logo w-auto">
                    {/*<img src={props.layoutColorMode === 'light' ? 'assets/layout/images/Logo SEC HÍBRIDO 2022_Mesa de trabajo 1.svg' : 'assets/layout/images/LOGOTIPO SEC PNG.png'} alt="logo"/>*/}
                    <img src={props.layoutColorMode === 'light' ? 'assets/layout/images/Logo SEC HÍBRIDO 2022_BLANCO.svg' : 'assets/layout/images/LOGOTIPO SEC PNG.png'} alt="logo" />
                    <div style={{ color: 'white', display: 'flex', marginLeft: '0.5rem', marginTop: '0.5rem' }}>
                        <div style={{ height: '4vh', borderLeft: '1px solid #ffffff', marginRight: '1rem' }} />
                        <div className='mt-2'>
                            <h5>Sistema de Gestión de {LABELTEXT}</h5>
                        </div>
                    </div>
                </div>
                {(false) &&
                    <button type="button" className="p-link  layout-menu-button layout-topbar-button" onClick={props.onToggleMenuClick}>
                        <i className="pi pi-bars" />
                    </button>
                }

                <button type="button" className="p-link layout-topbar-menu-button layout-topbar-button" onClick={props.onMobileTopbarMenuClick}>
                    <i id="iconOpcMenu" className="pi pi-ellipsis-v" />
                </button>

                <ul className={classNames("layout-topbar-menu lg:flex origin-top", { 'layout-topbar-menu-mobile-active': props.mobileTopbarMenuActive })}>
                    <li>
                        {handleAvatar()}
                    </li>
                </ul>

                <Dialog
                    id='modalVideotutorial'
                    visible={videotutorial}
                    draggable={false}
                    blockScroll={true}
                    closable={true}
                    style={{ width: "90vw", maxWidth: "800px" }}
                    onHide={() => {
                        setVideotutorial(false);
                        setVideoUrl("");
                        localStorage.setItem("videoTutorialVisto", "true");
                        setCicloescolar2(true);
                    }}

                    header={
                        <div className="grid" style={{ alignItems: 'center', backgroundColor: '#9b2f3e', color: "white" }} >
                            <div className="col-12"> {'VIDEOTUTORIAL "CARGA DE EVIDENCIAS"'}</div>
                        </div>
                    }
                    footer={
                        <div style={{ float: "right" }}>
                        </div>
                    }
                >
                    {videoUrl && (
                        <div style={{ position: "relative", width: "100%", paddingTop: "56.25%", width: "100%", }}>
                            <iframe
                                src={videoUrl}
                                title="YouTube video"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    border: "none"
                                }}
                            />
                        </div>
                    )}
                </Dialog>

                <Dialog
                    id='modalIngresoCiclo'
                    visible={cicloescolar2}
                    draggable={false}
                    blockScroll={true}
                    closable={false}
                    style={{ width: '400px', marginLeft: '10px', marginRight: '10px', height: '200px' }}
                    header={
                        <div className="grid" style={{ alignItems: 'center', backgroundColor: '#9b2f3e', color: "white" }} >
                            <div className="col-12"> {"INGRESO DE CICLO ESCOLAR"}</div>
                        </div>
                    }
                    footer={
                        <div style={{ float: "right" }}>
                            <div>
                                <Button label="Guardar" disabled={disableGuardar} className="p-button p-component" onClick={() => {
                                    if (selectedCiclo !== null) {
                                        handleCiclo(selectedCiclo)
                                        //navigate(0);
                                        // onHide("cicloescolar")
                                        AbriConfirmacion()
                                    } else {
                                        const ciclosn = getCiclos.find(x => x.IdCicloEscolar === ciclo)
                                        handleCiclo(ciclosn)
                                        //navigate(0);
                                        // onHide("cicloescolar")
                                        AbriConfirmacion()
                                    }
                                }} ></Button>
                            </div>
                        </div>
                    }
                >
                    <div className='text-center'>
                        <label className='mr-3 mt-0'>Ciclo escolar</label>
                        <Dropdown className="w-full md:w-14rem" options={getCiclos} optionLabel="Descripcion" optionValue='IdCicloEscolar' placeholder="Selecciona" value={ciclo} onChange={(e) => seleccionarCiclo(e.value)} />
                    </div>
                    {/* <div style={{ width: '100%', height: '100%', overflow: 'hidden' }} dangerouslySetInnerHTML={{ __html: file }} /> */}
                </Dialog>

                <Dialog
                    id='modalCambioCiclo'
                    visible={cicloescolar}
                    draggable={false}
                    blockScroll={true}
                    closable={false}
                    style={{ width: '400px', marginLeft: '10px', marginRight: '10px', height: '200px' }}
                    header={
                        <div className="grid" style={{ alignItems: 'center', backgroundColor: '#9b2f3e', color: "white" }} >
                            <div className="col-12"> {"CAMBIO DE CICLO ESCOLAR"}</div>
                        </div>
                    }
                    footer={
                        <div style={{ float: "right" }}>
                            <div>
                                <Button label="Cancelar" className="p-button-outlined p-component" onClick={() => { setCicloescolar(false) }}></Button>
                                <Button label="Guardar" disabled={disableGuardar} className="p-button p-component" onClick={() => {
                                    if (selectedCiclo !== null) {
                                        handleCiclo(selectedCiclo)
                                        //navigate(0);
                                        // onHide("cicloescolar")
                                        AbriConfirmacion()
                                    } else {
                                        const ciclosn = getCiclos.find(x => x.IdCicloEscolar === ciclo)
                                        handleCiclo(ciclosn)
                                        //navigate(0);
                                        // onHide("cicloescolar")
                                        AbriConfirmacion()
                                    }
                                }} ></Button>
                            </div>
                        </div>
                    }
                >
                    <div className='text-center'>
                        <label className='mr-3 mt-0'>Ciclo escolar</label>
                        <Dropdown className="w-full md:w-14rem" options={getCiclos} optionLabel="Descripcion" optionValue='IdCicloEscolar' placeholder="Selecciona" value={ciclo} onChange={(e) => seleccionarCiclo(e.value)} />
                    </div>
                    {/* <div style={{ width: '100%', height: '100%', overflow: 'hidden' }} dangerouslySetInnerHTML={{ __html: file }} /> */}
                </Dialog>

                <Dialog
                    id='modalAvisoCambioCiclo'
                    visible={dialogConfirmar}
                    draggable={false}
                    closable={false}
                    blockScroll={true}
                    style={{ width: '400px', marginLeft: '10px', marginRight: '10px', height: '200px' }}
                    header={
                        <div className="grid" style={{ alignItems: 'center', backgroundColor: '#9b2f3e', color: "white" }} >
                            <div className="col-12"> {"AVISO"}</div>
                        </div>
                    }
                    footer={
                        <div style={{ float: "right" }}>
                            <div>
                                {/*                                 <Button label="No" icon='pi pi-times' className="p-button-outlined p-component" onClick={() => {setDialogConfirmar(false); setCiclo(null)}}></Button>
 */}                                <Button label="Aceptar" icon='pi pi-check' className="p-button p-component" loading={confirmLoading} onClick={() => { onHide("cicloescolar"); onHide("dialogConfirmar"); window.location.reload(); }}></Button>
                            </div>
                        </div>
                    }
                    onHide={() => onHide("dialogConfirmar")}
                >
                    <div className="flex align-items-center justify-content-center">
                        <label style={{ fontSize: '14px', textAlign: 'center' }}>Ciclo escolar actualizado con éxito <br /><strong>{selectedCiclo !== null ? selectedCiclo.Descripcion : getCiclos.length > 0 && getCiclos.find(x => x.IdCicloEscolar === ciclo).Descripcion}</strong></label>
                    </div>
                </Dialog>
            </div>
        </>
    );
}